import {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';


import {
  addToCart as addCartApi,
  updateCartItem as updateCartApi,
  removeCartItem as removeCartApi,
  clearCart as clearCartApi,
} from '@/lib/cart';

type CartItem = {
  id: number;
  quantity: number;
  price: number;

  product: {
    id: number;
    name: string;
    sale_price: number;
    price: number;
    stock_qty: number;

    brand: {
      id:number;
      name:string;
      tier:string;
    };

    product_images?: {
      id: number;
      image_url: string;
    }[];
  };
};

type CartType = {
  id: number;
  session_token: string;
  cart_items: CartItem[];
};

type CartContextType = {
  addToCart: (
    productId: number,
    quantity?: number
  ) => void;

  updateCartItem: (
    cartItemId: number,
    quantity: number
  ) => void;

  removeFromCart: (
    cartItemId: number
  ) => void;

  clearCart: () => void;
};

const CartContext =
  createContext<CartContextType | null>(null);

export const CartProvider = ({
  children,
}: {
  children: ReactNode;
}) => {


const [cart, setCart] = useState<CartType | null>(null);

  /**
   * ADD TO CART
   */
  const addToCart = (
    productId: number,
    quantity: number = 1
  ) => {

    addCartApi(
      {
        product_id: productId,
        quantity,
      },
      {
        preserveScroll: true,
      }
    );
  };

  /**
   * UPDATE CART ITEM
   */
  const updateCartItem = (
    cartItemId: number,
    quantity: number
  ) => {

    updateCartApi(
      cartItemId,
      quantity,
    );
  };

  /**
   * REMOVE CART ITEM
   */
  const removeFromCart = (
    cartItemId: number
  ) => {

    removeCartApi(cartItemId);
  };

  /**
   * CLEAR CART
   */
  const clearCart = () => {

    if (!cart) return;

    clearCartApi(cart.id);
  };



  return (
    <CartContext.Provider
      value={{
        addToCart,
        updateCartItem,
        removeFromCart,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {

  const context = useContext(CartContext);

  if (!context) {
    throw new Error(
      'useCart must be used within CartProvider'
    );
  }

  return context;
};